import { Outlet } from 'react-router-dom';
import { IconNavChartPie, IconNavUsers } from '../../components/icons';
import { AppShellGrid, type NavEntry } from '../../components/Sidebar';
import { useDict } from '../../i18n/dictionary';
import { useAppCrumb } from '../../layouts/AppLayout';
import { adminDict } from './i18n';

export function AdminLayout() {
  const t = useDict(adminDict);
  useAppCrumb('admin', t.appName, '/admin');
  const nav: NavEntry[] = [
    {
      key: 'overview',
      href: '/admin',
      label: t.overview,
      icon: IconNavChartPie,
      end: true,
    },
    { key: 'users', href: '/admin/users', label: t.users, icon: IconNavUsers },
  ];
  return (
    <AppShellGrid items={nav}>
      <Outlet />
    </AppShellGrid>
  );
}
